export default __webpack_public_path__ + "static/media/044-fish.0a267a35.png";